<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t("categorias") }}</li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <!-- El negocio y las cifras, en la misma linea y dentro de una `card`, igual que
             la cabecera de Etiquetas del negocio. El rastro de migas ya dice donde estas,
             asi que no se repite el titulo.

             Lo que decia el subtitulo -"son del negocio: lo que cambies aqui se aplica a
             sus N terminales"- vive ahora en la cifra de TERMINALES, y los formularios de
             crear y editar lo siguen diciendo con todas las letras al guardar. -->
        <div class="card">
          <div class="ficha-superior">
            <div class="campo-negocio">
              <label>{{ $t("negocio") }}</label>
              <el-select
                class="select-default"
                size="large"
                v-model="idBusiness"
                filterable
                :placeholder="$t('seleccionaNegocio')"
                @change="cargar()"
              >
                <el-option
                  v-for="business in listBusinesses"
                  class="select-primary"
                  :value="business.id"
                  :label="business.establishmentName"
                  :key="business.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="ficha-resumen" v-if="cargado">
              <div class="ficha-dato">
                <b>{{ resumen.categorias }}</b>
                <span>{{ $t("categorias") }}</span>
              </div>
              <div class="ficha-dato">
                <b>{{ resumen.productos }}</b>
                <span>{{ $t("productos") }}</span>
              </div>
              <div class="ficha-dato">
                <b>{{ totalTerminales }}</b>
                <span>{{ $t("terminales") }}</span>
              </div>
              <!-- Solo cuando las hay. Un "0 DESIGUALES" permanente ocupa sitio para
                   decir que no pasa nada, y compite con las tres cifras que si informan.
                   Cuando aparece, siempre es un problema, asi que va en ambar fijo. -->
              <div class="ficha-dato ojo" v-if="desiguales">
                <b>{{ desiguales }}</b>
                <span>{{ $t("desiguales") }}</span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="cargado">
          <!-- Avisos. Cada uno lleva al lado la accion que lo arregla. -->
          <div class="avisos" v-if="avisos.length">
            <!-- Con varios, el orden importa: cada arreglo puede cambiar los de debajo. -->
            <p class="avisos-orden" v-if="variosAvisos">{{ $t("consejoOrdenAvisos") }}</p>
            <div v-for="(aviso, i) in avisos" :key="'av' + i" class="aviso" :class="{ rojo: aviso.rojo, info: aviso.info }">
              <span class="aviso-ico">{{ aviso.rojo ? "!" : aviso.info ? "i" : "⚠" }}</span>
              <p v-html="aviso.texto"></p>
              <button
                v-if="aviso.consejo"
                type="button"
                class="aviso-ayuda"
                :aria-expanded="consejoAbierto === aviso.clave ? 'true' : 'false'"
                @click="consejoAbierto = consejoAbierto === aviso.clave ? '' : aviso.clave"
              >
                {{ $t("comoLoSoluciono") }}
                <i class="fa" :class="consejoAbierto === aviso.clave ? 'fa-angle-up' : 'fa-angle-down'"></i>
              </button>
              <button
                v-if="aviso.accion"
                type="button"
                class="aviso-btn"
                @click="aviso.accion()"
                :disabled="guardando"
              >
                {{ aviso.etiqueta }}
              </button>
              <!-- Segunda salida, para los avisos con dos arreglos igual de validos. -->
              <button
                v-if="aviso.accion2"
                type="button"
                class="aviso-btn"
                @click="aviso.accion2()"
                :disabled="guardando"
              >
                {{ aviso.etiqueta2 }}
              </button>
              <!-- Textos fijos de las traducciones, sin nombres dentro: el v-html es solo
                   para la lista de pasos. -->
              <div v-if="aviso.consejo && consejoAbierto === aviso.clave" class="aviso-consejo" v-html="$t(aviso.consejo)"></div>
            </div>
          </div>

          <!-- Grupos: se ve uno cada vez. -->
          <nav class="arb-barra" :aria-label="$t('gruposDeCategorias')">
            <button
              v-for="g in [1, 2, 3, 4]"
              :key="'tab' + g"
              type="button"
              :aria-current="vista === g ? 'true' : 'false'"
              @click="irA(g)"
            >
              {{ $t("grupo") }} {{ g }}
              <span class="cnt">{{ ocupadasDe(g) }}/{{ porGrupo }}</span>
            </button>
            <span class="sep"></span>
            <!-- Solo tiene sentido viendo los cuatro: con un grupo no hay nada que
                 repartir en columnas. -->
            <span v-if="vista === 'todos'" class="disposicion">
              <button
                type="button"
                class="disp-btn"
                :aria-pressed="disposicion === 'lista' ? 'true' : 'false'"
                :title="$t('vistaListado')"
                :aria-label="$t('vistaListado')"
                @click="disposicion = 'lista'"
              >
                <i class="fa fa-bars"></i>
              </button>
              <button
                type="button"
                class="disp-btn"
                :aria-pressed="disposicion === 'columnas' ? 'true' : 'false'"
                :title="$t('vistaColumnas')"
                :aria-label="$t('vistaColumnas')"
                @click="disposicion = 'columnas'"
              >
                <i class="fa fa-th-large"></i>
              </button>
            </span>

            <button
              type="button"
              :aria-current="vista === 'todos' ? 'true' : 'false'"
              @click="irA('todos')"
            >
              {{ $t("verLos4Grupos") }}
            </button>
          </nav>

          <div class="grupos" :class="{ rejilla: vista === 'todos' && disposicion === 'columnas' }">
          <div v-for="grupo in gruposVisibles" :key="'g' + grupo.grupo" class="sector-card" :class="'g' + grupo.grupo">
            <div class="sector-cabecera">
              <span class="sector-cabecera-titulo">{{ $t("grupo") }} {{ grupo.grupo }}</span>
              <span class="sector-cabecera-resumen">
                {{ ocupadasDe(grupo.grupo) }} {{ $t("catDe") }} {{ porGrupo }} ·
                {{ $t("pantallaDelTerminal", { n: grupo.grupo }) }}
              </span>
              <!-- Solo sale cuando hay algo que reindexar: sin huecos en medio, el
                   boton no haria nada y seria un mando muerto en la cabecera. -->
              <button
                v-if="tieneHuecos(grupo)"
                type="button"
                class="btn btn-claro"
                :disabled="guardando"
                @click="pedirReindexar(grupo.grupo)"
              >
                {{ $t("reindexar") }}
              </button>
              <button
                type="button"
                class="btn btn-verde"
                :disabled="ocupadasDe(grupo.grupo) >= porGrupo || guardando"
                @click="empezarAlta(grupo.grupo)"
              >
                {{ ocupadasDe(grupo.grupo) >= porGrupo ? $t("grupoCompleto") : $t("anadirCategoria") }}
              </button>
            </div>

            <table
              class="sector-tabla"
              v-if="grupo.categorias.length || grupo.productosSinCategoria || nuevoEn === grupo.grupo"
            >
              <thead>
                <tr>
                  <th>{{ $t("categoria") }}</th>
                  <th class="num">{{ $t("productos") }}</th>
                  <th class="acc">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="cat in grupo.categorias">
                  <tr v-if="editando === cat.code" :key="'e' + cat.code" class="edit-fila">
                    <td colspan="3">
                      <div class="edit-linea">
                        <input
                          type="text"
                          class="form-control"
                          v-model="nombreEditado"
                          :placeholder="$t('nombreCategoria')"
                          @keyup.enter="guardarEdicion(cat)"
                          :ref="'inp' + cat.code"
                        />
                        <button type="button" class="btn btn-verde" :disabled="guardando" @click="guardarEdicion(cat)">
                          {{ $t("guardar") }}
                        </button>
                        <button type="button" class="btn btn-claro" @click="cancelar()">{{ $t("cancelar") }}</button>
                      </div>
                      <p class="edit-nota">{{ $tc("seGuardaEnTerminales", totalTerminales, { n: totalTerminales }) }}</p>
                    </td>
                  </tr>
                  <!-- Ranura sin nombre. Se pinta EN SU SITIO, no al final: al eliminar
                       una categoria su fila se queda -solo se le vacia el nombre- y verla
                       aqui es lo que cuenta que ahi hubo una y que su sitio sigue
                       reservado. Sin esto las demas salen seguidas y parece que se han
                       recolocado.

                       Con productos dentro NO es un hueco libre: es la fila "Sin
                       categoria". Nombrarla no crearia una categoria, adoptaria en
                       silencio los productos que ya tiene, asi que ahi no se ofrece
                       usarla sino verlos. -->
                  <tr v-else-if="!cat.nombre" :key="'h' + cat.code" class="sin-cat">
                    <td>
                      <span class="cat-nombre">{{ etiquetaHueco(cat) }}</span>
                      <span class="cat-estado warn" v-if="cat.productos">{{ $t("sinCategoriaExplica") }}</span>
                      <span class="cat-estado warn" v-else-if="cat.filas">{{ $t("huecoConBajasExplica") }}</span>
                      <span class="cat-estado" v-else>{{ $t("huecoLibreExplica") }}</span>
                    </td>
                    <td class="num">{{ cat.productos }}</td>
                    <td class="acc">
                      <button
                        v-if="cat.productos"
                        type="button"
                        class="arb-btn arb-btn-ver"
                        :title="$t('verProductos')"
                        :aria-label="$t('verProductos')"
                        @click="verProductos(grupo.grupo)"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                      <button
                        v-else-if="!cat.filas"
                        type="button"
                        class="arb-btn arb-btn-editar"
                        :title="$t('usarEsteHueco')"
                        :aria-label="$t('usarEsteHueco')"
                        :disabled="guardando"
                        @click="empezarEdicion(cat)"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                      <!-- Solo productos de baja: nadie los ve, pero tienen la ranura
                           ocupada y bloquean Reindexar. Soltarlos la deja libre. -->
                      <button
                        v-else
                        type="button"
                        class="arb-btn arb-btn-editar"
                        :title="$t('liberarRanura')"
                        :aria-label="$t('liberarRanura')"
                        :disabled="guardando"
                        @click="pedirLiberar(cat)"
                      >
                        <i class="fa fa-chain-broken"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-else :key="'c' + cat.code">
                    <td>
                      <span class="cat-nombre">{{ cat.nombre }}</span>
                      <span class="cat-estado" :class="estadoDe(cat).clase">{{ estadoDe(cat).texto }}</span>
                    </td>
                    <td class="num">{{ cat.productos }}</td>
                    <td class="acc">
                      <!-- La misma salida que el aviso de arriba, aqui en su fila. La otra,
                           quitarla del terminal, es la X de siempre. -->
                      <button
                        v-if="cat.soloEn && cat.soloEn.length"
                        type="button"
                        class="arb-btn arb-btn-editar"
                        :title="$t('crearEnServidor')"
                        :aria-label="$t('crearEnServidor')"
                        :disabled="guardando"
                        @click="antesOrden(() => pedirIgualar(cat.code))"
                      >
                        <i class="fa fa-server"></i>
                      </button>
                      <button
                        type="button"
                        class="arb-btn arb-btn-editar"
                        :title="$t('editar')"
                        :aria-label="$t('editar')"
                        :disabled="guardando"
                        @click="empezarEdicion(cat)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        class="arb-btn arb-btn-borrar"
                        :title="$t('eliminar')"
                        :aria-label="$t('eliminar')"
                        :disabled="guardando"
                        @click="pedirBorrado(cat)"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </template>

                <tr v-if="nuevoEn === grupo.grupo" class="edit-fila">
                  <td colspan="3">
                    <div class="edit-linea">
                      <input
                        type="text"
                        class="form-control"
                        v-model="nombreNuevo"
                        :placeholder="$t('nombreCategoriaNueva')"
                        @keyup.enter="crear(grupo.grupo)"
                        ref="inpNuevo"
                      />
                      <button type="button" class="btn btn-verde" :disabled="guardando" @click="crear(grupo.grupo)">
                        {{ $t("crear") }}
                      </button>
                      <button type="button" class="btn btn-claro" @click="cancelar()">{{ $t("cancelar") }}</button>
                    </div>
                    <p class="edit-nota">{{ $tc("seCrearaAlFinalDelGrupo", totalTerminales, { g: grupo.grupo, n: totalTerminales }) }}</p>
                  </td>
                </tr>

              </tbody>
            </table>

            <p class="vacio" v-else>{{ $t("grupoVacio", { n: grupo.grupo }) }}</p>
          </div>
          </div>

          <!-- Ranuras que el terminal usa pero que no caben en los cuatro grupos. La
               pantalla de siempre las pierde; aqui al menos se ven. -->
          <div class="sector-card" v-if="fueraDeGrupo.length">
            <div class="sector-cabecera">
              <span class="sector-cabecera-titulo">{{ $t("fueraDeLosGrupos") }}</span>
              <span class="sector-cabecera-resumen">{{ $t("fueraDeLosGruposExplica") }}</span>
            </div>
            <table class="sector-tabla">
              <thead>
                <tr>
                  <th>{{ $t("categoria") }}</th>
                  <th class="num">{{ $t("productos") }}</th>
                  <th class="acc">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cat in fueraDeGrupo" :key="'f' + cat.code">
                  <td>
                    <span class="cat-nombre">{{ cat.nombre }}</span>
                    <span class="cat-estado" :class="estadoDe(cat).clase">{{ estadoDe(cat).texto }}</span>
                  </td>
                  <td class="num">{{ cat.productos }}</td>
                  <td class="acc">
                    <button
                      type="button"
                      class="arb-btn arb-btn-editar"
                      :title="$t('editar')"
                      :disabled="guardando"
                      @click="empezarEdicion(cat)"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pie">
            <button type="button" class="btn btn-claro" @click="irA(vista === 'todos' ? 1 : 'todos')">
              {{ vista === "todos" ? $t("verDeUnoEnUno") : $t("mostrarLos4Grupos") }}
            </button>
          </div>

          <p class="foot">{{ $t("notaGruposTerminal") }}</p>
        </template>
      </div>
    </div>

    <categoria-baja-modal
      ref="modalBaja"
      :categorias="todasLasCategorias"
      :terminales="totalTerminales"
      :ocupado="guardando"
      @confirmar="bajaConfirmada"
    />

    <productos-sin-categoria-modal
      ref="modalSinCategoria"
      :id-business="idBusiness"
      :categorias="todasLasCategorias"
      :terminales="totalTerminales"
      @asignados="productosAsignados"
    />

    <reindexar-grupo-modal
      ref="modalReindexar"
      :terminales="totalTerminales"
      :ocupado="guardando"
      @confirmar="reindexar"
    />

    <igualar-categorias-modal
      ref="modalIgualar"
      :terminales="totalTerminales"
      :ocupado="guardando"
      @confirmar="igualar"
    />

    <reordenar-categorias-modal
      ref="modalReordenar"
      :ocupado="guardando"
      @confirmar="reordenar"
    />

    <orden-primero-modal
      ref="modalOrdenPrimero"
      @reordenar="pedirReordenar"
      @continuar="continuarSinOrden"
    />
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Loading } from "element-ui";
import { Select, Option } from "element-ui";
import CategoriaBajaModal from "../../../Widgets/Categorias/CategoriaBajaModal.vue";
import ProductosSinCategoriaModal from "../../../Widgets/Categorias/ProductosSinCategoriaModal.vue";
import ReindexarGrupoModal from "../../../Widgets/Categorias/ReindexarGrupoModal.vue";
import IgualarCategoriasModal from "../../../Widgets/Categorias/IgualarCategoriasModal.vue";
import ReordenarCategoriasModal from "../../../Widgets/Categorias/ReordenarCategoriasModal.vue";
import OrdenPrimeroModal from "../../../Widgets/Categorias/OrdenPrimeroModal.vue";

export default {
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("categorias"));

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }

    this.getBusiness();
  },

  data() {
    return {
      loadingGeneral: null,
      guardando: false,
      cargado: false,

      listBusinesses: [],
      idBusiness: this.$route.params.idBusiness,

      grupos: [],
      fueraDeGrupo: [],
      terminales: [],
      // Clientes nuevos que aun no han subido su carta: la API los deja fuera de todo.
      terminalesPendientes: [],
      resumen: { categorias: 0, productos: 0, desiguales: 0, terminalesSinCategorias: [], nombresRepetidos: [] },

      porGrupo: 10,
      vista: 1,
      disposicion: "lista",
      editando: null,
      nombreEditado: "",
      nuevoEn: 0,
      nombreNuevo: "",
      // Lo que el usuario queria hacer cuando salto el aviso de reordenar primero.
      accionPendiente: null,
      // La `clave` del aviso con los pasos desplegados. Uno cada vez.
      consejoAbierto: ""
    };
  },

  computed: {
    // Los que llevan carta propia. Los espejos leen la del servidor: no se les escribe
    // nada y no cuentan en el "en todos los terminales".
    totalTerminales() {
      return this.terminales.filter(t => t.rol !== "espejo").length;
    },

    gruposVisibles() {
      if (this.vista === "todos") {
        return this.grupos;
      }

      return this.grupos.filter(g => g.grupo === this.vista);
    },

    // La linea de "arreglalos de arriba abajo" solo con dos o mas que pidan arreglo.
    variosAvisos() {
      return this.avisos.filter(a => !a.info).length > 1;
    },

    /**
     * Los avisos de arriba. Cada uno trae su accion, para que la deriva se arregle desde
     * la pantalla y no con un script.
     */
    avisos() {
      let lista = [];
      let vm = this;
      // Escapado: los avisos se pintan con v-html y los nombres de TPV vienen de la base.
      let escapar = s => String(s).replace(/[&<>"']/g, ch => "&#" + ch.charCodeAt(0) + ";");

      // El primero, y no por casualidad: con las teclas cruzadas entre terminales los
      // avisos de abajo cuentan mal -un "llama «BOTELLAS» a CHUPITOS" suele ser eso-, y
      // arreglarlos antes escribiria donde no toca. Las demas acciones pasan por
      // `antesOrden` mientras este siga en pie.
      if (this.hayDesorden) {
        lista.push({
          clave: "orden",
          consejo: "consejoOrdenDistinto",
          rojo: true,
          texto: this.$tc("avisoOrdenDistinto", this.terminalesDesordenados, { n: this.terminalesDesordenados }),
          etiqueta: this.$t("reordenar"),
          accion: () => vm.pedirReordenar()
        });
      }

      // UNO POR CADA UNA, no solo la primera. Antes esto empujaba `conflicto[0]` y
      // punto: con dos categorias discrepantes en grupos distintos solo se veia una, y
      // la otra no tenia forma de repararse desde la pantalla. Cada aviso lleva su
      // propio code, que es lo que "Unificar" necesita para resolver ESA.
      //
      // Las que el servidor no tiene van en el aviso de abajo, que ya las cubre.
      this.todasLasCategorias
        .filter(
          c =>
            c.otrosNombres &&
            c.otrosNombres.length &&
            !vm.teclasCruzadas.has(String(c.code)) &&
            !(c.soloEn && c.soloEn.length)
        )
        .forEach(function(c) {
          lista.push({
            clave: "nombre" + c.code,
            consejo: "consejoOtroNombre",
            rojo: true,
            texto: vm.$t("avisoOtroNombre", {
              otro: escapar(c.otrosNombres[0]),
              nombre: escapar(c.nombre),
              g: c.grupo
            }),
            etiqueta: vm.$t("unificar"),
            accion: () => vm.antesOrden(() => vm.pedirIgualar(c.code))
          });
        });

      // Categorias que el servidor no tiene y algun cliente si. El servidor es el maestro,
      // asi que esto no deberia pasar, pero la salida no es automatica en ningun sentido:
      // o es buena y se crea en el servidor, o sobra y se quita del terminal -con sus
      // productos a otra categoria-. Las dos son acciones que ya existen: Unificar de esa
      // sola y Eliminar.
      this.todasLasCategorias
        .filter(c => c.soloEn && c.soloEn.length && !vm.teclasCruzadas.has(String(c.code)))
        .forEach(function(c) {
          lista.push({
            clave: "solo" + c.code,
            consejo: "consejoSoloEnClientes",
            rojo: true,
            texto: vm.$tc("avisoSoloEnClientes", c.soloEn.length, {
              nombre: escapar(c.nombre),
              g: c.grupo,
              terminales: c.soloEn.map(t => "«" + escapar(t) + "»").join(", ")
            }),
            etiqueta: vm.$t("crearEnServidor"),
            accion: () => vm.antesOrden(() => vm.pedirIgualar(c.code)),
            etiqueta2: vm.$tc("quitarDelTerminal", c.soloEn.length),
            accion2: () => vm.antesOrden(() => vm.pedirBorrado(c))
          });
        });

      (this.resumen.nombresRepetidos || []).forEach(rep => {
        lista.push({
          clave: "repetido" + rep.nombre,
          consejo: "consejoNombreRepetido",
          rojo: true,
          texto: vm.$t("avisoNombreRepetido", {
            nombre: escapar(rep.nombre),
            g1: rep.ranuras[0].grupo,
            g2: rep.ranuras[1].grupo,
            p1: rep.ranuras[0].productos,
            p2: rep.ranuras[1].productos
          }),
          etiqueta: null,
          accion: null
        });
      });

      // Un solo aviso para los dos casos. Un terminal sin ninguna categoria es el caso
      // extremo de "no han llegado a todos": sus categorias cuentan ya como desiguales, y
      // el boton es el mismo. Con dos avisos se leia dos veces lo mismo.
      let sinDatos = this.resumen.terminalesSinCategorias || [];
      let nombresSinDatos = sinDatos.map(t => "«" + escapar(t.nombre) + "»").join(", ");

      if (this.desiguales) {
        let texto = this.$tc("avisoDesiguales", this.desiguales, { n: this.desiguales });

        if (sinDatos.length) {
          texto += " " + this.$tc("avisoDesigualesSinNinguna", sinDatos.length, { terminales: nombresSinDatos });
        }

        lista.push({
          clave: "desiguales",
          consejo: "consejoDesiguales",
          rojo: false,
          texto: texto,
          etiqueta: this.$t("aplicarATodos"),
          accion: () => vm.antesOrden(() => vm.pedirIgualar(""))
        });
      } else if (sinDatos.length) {
        // Sin desiguales, un terminal vacio es que el negocio no tiene categorias que
        // llevarle: "Aplicar a todos" no haria nada, asi que va sin boton.
        lista.push({
          clave: "sinDatos",
          consejo: "consejoTerminalesSinCategorias",
          rojo: false,
          texto: this.$tc("avisoTerminalesSinCategorias", sinDatos.length, { n: sinDatos.length }),
          etiqueta: null,
          accion: null
        });
      }

      // Dos procedencias, un solo aviso. Los de `productosSinCategoria` estan dentro de
      // una ranura sin nombre -herencia: filas que se quedaron con productos dentro-, y
      // los `productosSueltos` ya no cuelgan de ninguna: ahi van los de una categoria
      // eliminada sin elegir destino. Los sueltos no son de ningun grupo, que es por lo
      // que este aviso esta arriba y no dentro de uno.
      let sinCategoria = this.grupos.reduce((s, g) => s + g.productosSinCategoria, 0)
        + (this.resumen.productosSueltos || 0);

      if (sinCategoria) {
        lista.push({
          clave: "sinCategoria",
          consejo: "consejoProductosSinCategoria",
          rojo: false,
          texto: this.$tc("avisoProductosSinCategoria", sinCategoria, { n: sinCategoria }),
          etiqueta: this.$t("verProductos"),
          accion: () => vm.antesOrden(() => vm.verProductos())
        });
      }

      // El ultimo y sin boton: no hay nada que arreglar, solo explicar por que un
      // terminal del negocio no aparece en las cuentas de arriba. Se copiara la carta del
      // servidor por su cuenta y, al subirla, entrara aqui como uno mas.
      if (this.terminalesPendientes.length) {
        lista.push({
          clave: "pendiente",
          consejo: "consejoTerminalPendiente",
          info: true,
          texto: this.$tc("avisoTerminalPendiente", this.terminalesPendientes.length, {
            terminales: this.terminalesPendientes.map(t => "«" + escapar(t.nombre) + "»").join(", ")
          }),
          etiqueta: null,
          accion: null
        });
      }

      return lista;
    },

    /**
     * Terminales con alguna categoria en otra tecla que en el servidor. Los que solo
     * traen nombres repetidos -que no se pueden emparejar- no cuentan: ahi reordenar no
     * haria nada, y avisar de algo que el boton no arregla seria un aviso muerto.
     */
    terminalesDesordenados() {
      return (this.resumen.ordenDistinto || []).filter(
        t => !t.sinSitio && (t.movimientos || []).some(m => m.motivo === "servidor")
      ).length;
    },

    hayDesorden() {
      return this.terminalesDesordenados > 0;
    },

    /**
     * Teclas que Reordenar va a tocar en algun terminal. Con las teclas cruzadas, la `c`
     * del servidor y la del cliente son categorias distintas, y eso sale como un "un
     * terminal la llama..." en cada una y como dos desiguales. Es UN problema, no tres,
     * y se arregla reordenando: "Unificar" ahi escribiria el nombre del servidor encima
     * de otra categoria del cliente. Esas teclas no avisan por su cuenta hasta entonces.
     */
    teclasCruzadas() {
      let teclas = new Set();

      (this.resumen.ordenDistinto || [])
        .filter(t => !t.sinSitio)
        .forEach(t => {
          (t.movimientos || [])
            .filter(m => m.motivo === "servidor")
            .forEach(m => {
              teclas.add(String(m.de));
              teclas.add(String(m.a));
            });
        });

      return teclas;
    },

    /**
     * Las desiguales de la API menos las que solo lo son por estar en otra tecla. Mismo
     * criterio que la API para contarlas: con nombre y dentro de los cuatro grupos.
     */
    desiguales() {
      let cruzadas = this.grupos.reduce(
        (n, g) =>
          n +
          g.categorias.filter(
            c =>
              c.nombre !== "" &&
              this.teclasCruzadas.has(String(c.code)) &&
              // Las que solo tienen los clientes ya no las cuenta la API.
              !(c.soloEn && c.soloEn.length) &&
              (c.faltaEn || (c.otrosNombres && c.otrosNombres.length))
          ).length,
        0
      );

      return Math.max(0, (this.resumen.desiguales || 0) - cruzadas);
    },

    nombreServidor() {
      let servidor = this.terminales.find(t => t.rol === "servidor");

      return servidor ? servidor.nombre : "";
    },

    todasLasCategorias() {
      let todas = [];
      this.grupos.forEach(g => {
        todas = todas.concat(g.categorias);
      });
      return todas.concat(this.fueraDeGrupo);
    }
  },

  methods: {
    getBusiness() {
      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (response.data.response) {
            if (!vm.idBusiness) {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.listBusinesses = response.data.result;
            vm.cargar();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cargar() {
      this.cancelar();
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      var config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "businessCategories/getBusinessCategories", config)
        .then(function(response) {
          vm.loadingGeneral.close();

          if (!response.data.response) {
            vm.cargado = false;
            vm.error(response.data.message);
            return;
          }

          let r = response.data.result;
          vm.grupos = r.grupos;
          vm.fueraDeGrupo = r.fueraDeGrupo;
          vm.terminales = r.terminales;
          vm.terminalesPendientes = r.terminalesPendientes || [];
          vm.resumen = r.resumen;
          vm.cargado = true;
        })
        .catch(function(error) {
          vm.loadingGeneral.close();
          console.log(error);
        });
    },

    ocupadasDe(g) {
      let grupo = this.grupos.filter(x => x.grupo === g)[0];
      return grupo ? grupo.ocupadas : 0;
    },

    /**
     * El estado de coherencia entre terminales, dicho en castellano y no en columnas.
     */
    estadoDe(cat) {
      if (this.teclasCruzadas.has(String(cat.code))) {
        return { clase: "warn", texto: this.$t("enOtraTeclaEnTerminal") };
      }

      if (cat.soloEn && cat.soloEn.length) {
        return {
          clase: "mal",
          texto: this.$t("soloEnTerminalSinServidor", { terminales: cat.soloEn.map(t => "«" + t + "»").join(", ") })
        };
      }

      if (cat.otrosNombres && cat.otrosNombres.length) {
        return { clase: "mal", texto: this.$t("unTerminalLaLlama", { otro: cat.otrosNombres[0] }) };
      }

      if (cat.faltaEn) {
        return { clase: "warn", texto: this.$tc("pendienteEnTerminales", cat.faltaEn, { n: cat.faltaEn }) };
      }

      return { clase: "ok", texto: this.$tc("enTodosLosTerminales", this.totalTerminales, { n: this.totalTerminales }) };
    },

    irA(destino) {
      this.cancelar();
      this.vista = destino;
    },

    cancelar() {
      this.editando = null;
      this.nombreEditado = "";
      this.nuevoEn = 0;
      this.nombreNuevo = "";
    },

    empezarEdicion(cat) {
      this.cancelar();
      this.editando = cat.code;
      this.nombreEditado = cat.nombre;
    },

    empezarAlta(grupo) {
      this.cancelar();
      this.nuevoEn = grupo;

      let vm = this;
      this.$nextTick(function() {
        if (vm.$refs.inpNuevo && vm.$refs.inpNuevo[0]) {
          vm.$refs.inpNuevo[0].focus();
        } else if (vm.$refs.inpNuevo) {
          vm.$refs.inpNuevo.focus();
        }
      });
    },

    guardarEdicion(cat) {
      this.guardar({ code: cat.code, grupo: 0, name: this.nombreEditado });
    },

    crear(grupo) {
      this.guardar({ code: "", grupo: grupo, name: this.nombreNuevo });
    },

    /**
     * Unico camino de escritura de nombre. El code vacio es un alta; con code, un
     * renombrado. En los dos casos la API escribe en todos los terminales.
     */
    guardar(datos) {
      if (!String(datos.name).trim()) {
        this.error(this.$t("nombreVacio"));
        return;
      }

      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        code: datos.code,
        grupo: datos.grupo,
        name: datos.name,
        jwt: this.$store.getters.jwt
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/saveBusinessCategory", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.error(response.data.message);
            return;
          }

          let r = response.data.result;

          vm.aviso(
            vm.$tc(datos.code ? "categoriaGuardada" : "categoriaCreada", r.terminales, { n: r.terminales })
          );

          (r.avisos || []).forEach(function(texto) {
            vm.aviso(texto, "warning");
          });

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          console.log(error);
        });
    },

    /**
     * Antes de quitar una categoria hay que decir a donde van sus productos. Si no se
     * elige destino se quedan sin categoria, pero eso se elige a proposito: no es lo
     * que pasa por no contestar.
     *
     * La decision se toma en CategoriaBajaModal, calcado del de etiquetas: ensena las
     * consecuencias antes de pedir nada, y "dejarlos sin categoria" es una casilla que
     * hay que marcar a mano. Antes esto eran dos `swal` encadenados, y el segundo -el
     * que avisaba de lo que implica- solo aparecia despues de haber elegido.
     */
    pedirBorrado(cat) {
      this.$refs.modalBaja.abrir(cat);
    },

    /**
     * Soltar los productos de baja de una ranura sin nombre, para que quede libre. Un
     * `swal` basta: no hay nada que elegir, y los productos de baja no se ven en ningun
     * sitio, asi que soltarlos no cambia lo que vende el camarero.
     */
    pedirLiberar(cat) {
      swal({
        title: this.$t("liberarRanuraTitulo"),
        text: this.$t("liberarRanuraTexto"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("liberarRanura"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.liberar(cat.code);
        }
      });
    },

    liberar(code) {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = { idBusiness: this.idBusiness, code: code, jwt: this.$store.getters.jwt };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/releaseBusinessCategorySlot", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.error(response.data.message);
            return;
          }

          vm.aviso(vm.$t("ranuraLiberada"));
          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.error(vm.$t("errorInesperado"));
          console.log(error);
        });
    },

    bajaConfirmada(datos) {
      this.borrar(datos.code, datos.codeDestino);
    },

    borrar(code, codeDestino) {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        code: code,
        codeDestino: codeDestino,
        jwt: this.$store.getters.jwt
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/deleteBusinessCategory", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            // El error se ensena DENTRO del modal, que sigue abierto: asi no se pierde
            // el destino ya elegido si solo hay que reintentar.
            vm.$refs.modalBaja.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalBaja.cerrar();

          let r = response.data.result;

          if (r.productosMovidos) {
            vm.aviso(vm.$tc("productosMovidos", r.productosMovidos, { n: r.productosMovidos }));
          } else if (r.productosSinCategoria) {
            vm.aviso(vm.$tc("productosSinCategoriaAhora", r.productosSinCategoria, { n: r.productosSinCategoria }), "warning");
          } else {
            vm.aviso(vm.$tc("categoriaEliminada", r.terminales, { n: r.terminales }));
          }

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalBaja.mostrarError(null);
          console.log(error);
        });
    },

    /**
     * Un hueco es una categoria sin nombre devuelta por la API. Solo llegan los de EN
     * MEDIO -los del final los recorta getBusinessCategories-, asi que si hay alguno es
     * que el grupo se puede compactar.
     */
    tieneHuecos(grupo) {
      return grupo.categorias.some(c => !c.nombre);
    },

    /**
     * Reindexar le cambia al camarero la carta de sitio y no se deshace con un boton,
     * asi que antes se ensena que categoria acaba en que tecla. Eso lo pinta el modal a
     * partir de las categorias del grupo, que ya vienen en orden y con sus huecos.
     */
    pedirReindexar(grupo) {
      let g = this.grupos.find(x => x.grupo === grupo);

      this.$refs.modalReindexar.abrir(grupo, g ? g.categorias : []);
    },

    reindexar(grupo) {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = { idBusiness: this.idBusiness, grupo: grupo, jwt: this.$store.getters.jwt };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/reindexBusinessCategories", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            // El error se ensena DENTRO del modal, que sigue abierto: el usuario acaba de
            // ver la prevision y la sigue teniendo delante mientras lee por que no se ha
            // podido. Igual que en el modal de baja.
            vm.$refs.modalReindexar.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalReindexar.cerrar();

          let r = response.data.result;

          if (!r.movidas) {
            vm.aviso(vm.$t("yaEstabanOrdenadas"));
            return;
          }

          vm.aviso(vm.$tc("categoriasReindexadas", r.movidas, { n: r.movidas }));
          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalReindexar.mostrarError(null);
          console.log(error);
        });
    },

    /**
     * Mientras haya terminales con las teclas cruzadas, las demas acciones pasan por aqui:
     * se avisa de que conviene reordenar antes y el usuario elige. No se bloquea, pero lo
     * recomendado es el boton principal.
     *
     * @param {Function} accion Lo que se iba a hacer.
     */
    antesOrden(accion) {
      if (!this.hayDesorden) {
        accion();
        return;
      }

      this.accionPendiente = accion;
      this.$refs.modalOrdenPrimero.abrir();
    },

    continuarSinOrden() {
      let accion = this.accionPendiente;
      this.accionPendiente = null;

      if (accion) {
        accion();
      }
    },

    pedirReordenar() {
      this.accionPendiente = null;
      this.$refs.modalReordenar.abrir(this.nombreServidor, this.resumen.ordenDistinto);
    },

    reordenar() {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/reorderBusinessCategories", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            // Dentro del modal, que sigue abierto, igual que en los demas.
            vm.$refs.modalReordenar.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalReordenar.cerrar();

          let r = response.data.result;
          vm.aviso(vm.$tc("categoriasReordenadas", r.movidas, { n: r.movidas }));

          if (r.saltados && r.saltados.length) {
            vm.aviso(vm.$t("reordenarSaltados", { terminales: r.saltados.join(", ") }), "warning");
          }

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalReordenar.mostrarError(null);
          console.log(error);
        });
    },

    /**
     * "Unificar" y "Aplicar a todos" le cambian al camarero el nombre de la categoria en
     * algun terminal, y el nombre que se pierde no vuelve con otro boton. Antes de
     * escribir, IgualarCategoriasModal ensena que terminal pasa a llamarla como.
     */
    pedirIgualar(code) {
      this.$refs.modalIgualar.abrir(code, this.todasLasCategorias);
    },

    /**
     * "Aplicar a todos": escribe el nombre bueno de cada categoria en los terminales
     * donde falta. Con code, solo esa.
     */
    igualar(code) {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = { idBusiness: this.idBusiness, code: code, jwt: this.$store.getters.jwt };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/syncBusinessCategories", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            // Dentro del modal, que sigue abierto, igual que en baja y reindexar.
            vm.$refs.modalIgualar.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalIgualar.cerrar();

          let r = response.data.result;
          vm.aviso(vm.$tc("categoriasIgualadas", r.aplicadas.length, { n: r.aplicadas.length }));

          if (r.saltadas && r.saltadas.length) {
            vm.aviso(vm.$tc("categoriasSaltadas", r.saltadas.length, { n: r.saltadas.length }), "warning");
          }

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalIgualar.mostrarError(null);
          console.log(error);
        });
    },

    /**
     * Antes esto sacaba de la pantalla al listado de productos, donde habia que buscarlos
     * uno a uno y editar cada ficha. Ahora los ensena aqui y deja colocarlos en bloque.
     *
     * @param {number} grupo 1-4 desde la fila "Sin categoria" de un grupo, o 0 desde el
     *                       aviso de arriba, que cuenta los de todo el negocio.
     */
    /**
     * Como se llama una ranura sin nombre, que puede estar en tres estados.
     *
     * `productos` son los de alta del terminal que manda -lo que se ensena- y `filas` es
     * todo lo que tiene dentro, de baja incluido. La diferencia importa: una ranura con 0
     * productos pero 5 filas NO es un hueco libre. Ofrecer "usar este hueco" ahi seria
     * mentir dos veces -la API lo rechaza, y reutilizarla arrastraria esas cinco a la
     * categoria nueva-.
     *
     * @param {Object} cat Fila de categoria devuelta por la API.
     *
     * @return {string}
     */
    etiquetaHueco(cat) {
      if (cat.productos) {
        return this.$t("sinCategoria");
      }

      return cat.filas ? this.$t("huecoConBajas") : this.$t("huecoLibre");
    },

    verProductos(grupo) {
      this.$refs.modalSinCategoria.abrir(grupo || 0);
    },

    productosAsignados(r) {
      this.aviso(this.$tc("productosAsignados", r.movidos, { n: r.movidos, categoria: r.nombreDestino }));
      this.cargar();
    },

    aviso(mensaje, tipo) {
      this.$notify({
        message: mensaje,
        icon: "nc-icon nc-check-2",
        timeout: 3000,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: tipo || "success"
      });
    },

    error(mensaje) {
      swal({
        title: this.$t("atencion"),
        text: mensaje,
        confirmButtonClass: "btn btn-info btn-fill",
        type: "error",
        buttonsStyling: false
      });
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    CategoriaBajaModal,
    ProductosSinCategoriaModal,
    ReindexarGrupoModal,
    IgualarCategoriasModal,
    ReordenarCategoriasModal,
    OrdenPrimeroModal
  }
};
</script>

<style scoped>
/* ---------------------------------------------------------------------------
   Categorias de un negocio.

   Las clases replican las de SectorProduct.vue a proposito: es la misma familia
   visual. Estan duplicadas porque los estilos con scope no cruzan de un
   componente a otro.
   --------------------------------------------------------------------------- */
/* Mismos valores que EtiquetasNegocio.vue: las dos cabeceras tienen que verse igual, y
   si una se mueve la otra se queda descolgada. */
.card {
    padding: 20px;
}

.ficha-superior {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}

.ficha-resumen {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.ficha-dato {
    background: #fff;
    border: 1px solid #e6e9ef;
    border-radius: 4px;
    padding: 8px 14px;
    text-align: center;
    min-width: 100px;
}

.ficha-dato b {
    display: block;
    font-size: 1.25em;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}

.ficha-dato span {
    font-size: 0.72em;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8b96a3;
}

/* La cifra de categorias desiguales solo se tiñe cuando hay alguna: en ambar, el
   mismo color con el que la ficha de producto marca lo que hay que mirar. */
.ficha-dato.ojo {
    background: rgba(214, 158, 46, 0.09);
    border-color: rgba(214, 158, 46, 0.25);
}

.ficha-dato.ojo b,
.ficha-dato.ojo span {
    color: #96690f;
}

.sector-card {
    border: 1px solid #e6e9ef;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
}

.sector-cabecera {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 14px 18px;
    background: #f7f9fb;
    border-bottom: 1px solid #e6e9ef;
}

.sector-cabecera-titulo {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.02em;
    font-weight: 600;
    color: #2c3e50;
}

.sector-cabecera-resumen {
    font-size: 0.85em;
    color: #7b8794;
    margin-left: auto;
}

/* El grupo se reconoce por su titulo y por el filo azul de la tarjeta. El badge con el
   numero repetia lo que el titulo ya dice, asi que sobraba. */
.g1,
.g2,
.g3,
.g4 { border-top: 2px solid #2c7fb8; }

/* ---------------------------------------------------------------------------
   Los cuatro grupos a la vez

   Con un solo grupo visible no hay rejilla que valga: la tarjeta ocupa el ancho.
   Al ver los cuatro, se reparten en 4 columnas si caben y en 2x2 si no. Se usan
   media queries y no `auto-fit`, que a los anchos habituales del panel daria 3
   columnas -y 3 de 4 deja una sola abajo, que es justo lo que se quiere evitar-.
   --------------------------------------------------------------------------- */
.grupos.rejilla {
    display: grid;
    gap: 16px;
    /* Cada tarjeta ocupa lo que necesita: sin esto, las cuatro crecen hasta la
       altura de la mas llena y los grupos vacios quedan como cajones enormes. */
    align-items: start;
}

.grupos.rejilla .sector-card {
    margin-bottom: 0;
}

@media (min-width: 700px) {
    .grupos.rejilla {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) {
    .grupos.rejilla {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

/* En columna estrecha la tabla no cabe con el aire de siempre: se recorta el
   relleno y se deja que el nombre parta, en vez de empujar los botones fuera. */
.grupos.rejilla .sector-cabecera,
.grupos.rejilla .vacio {
    padding: 12px 14px;
}

.grupos.rejilla .sector-tabla thead th,
.grupos.rejilla .sector-tabla tbody td {
    padding: 10px 14px;
}

.grupos.rejilla .cat-nombre {
    overflow-wrap: anywhere;
}

.campo-negocio {
    flex: 0 1 340px;
    min-width: 220px;
}

.campo-negocio .el-select {
    width: 100%;
}

.campo-negocio label {
    display: block;
    font-size: 0.74em;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #8b96a3;
    font-weight: 600;
    margin-bottom: 6px;
}

/* ---- Avisos ---- */
.avisos {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.aviso {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 11px 14px;
    border-radius: 4px;
    background: rgba(214, 158, 46, 0.09);
    border: 1px solid rgba(214, 158, 46, 0.25);
}

.aviso.rojo {
    background: rgba(161, 58, 47, 0.1);
    border-color: rgba(161, 58, 47, 0.22);
}

/* Informativo: no hay nada que arreglar, asi que ni ambar ni rojo. El azul del filo de
   los grupos. */
.aviso.info {
    background: rgba(44, 127, 184, 0.07);
    border-color: rgba(44, 127, 184, 0.22);
}

.aviso.info .aviso-ico {
    color: #2c7fb8;
    font-style: italic;
    font-family: Georgia, serif;
}

.aviso p {
    flex: 1 1 320px;
    margin: 0;
    font-size: 0.88em;
    color: #3d4a58;
}

.aviso-ico {
    flex: 0 0 auto;
    font-weight: 700;
    color: #96690f;
}

.aviso.rojo .aviso-ico {
    color: #a13a2f;
}

/* El mismo de EtiquetasNegocio.vue: tenido del color del aviso en vez de gris neutro, y
   empujado a la derecha con `margin-left: auto`. Aqui era gris y quedaba como un boton
   suelto dentro de una barra ambar. */
.aviso-btn {
    flex: 0 0 auto;
    margin-left: auto;
    border: 1px solid rgba(138, 100, 32, 0.45);
    background: rgba(255, 255, 255, 0.55);
    border-radius: 3px;
    padding: 5px 11px;
    font-size: 0.82em;
    font-weight: 600;
    color: #8a6420;
    white-space: nowrap;
}

.aviso-btn:hover {
    background: #fff;
    border-color: #8a6420;
}

.aviso.rojo .aviso-btn {
    border-color: rgba(161, 58, 47, 0.4);
    color: #a13a2f;
}

.aviso.rojo .aviso-btn:hover {
    border-color: #a13a2f;
}

/* Esta no esta en Etiquetas porque alli el boton nunca se desactiva; aqui si, mientras
   se guarda. */
/* El "como lo soluciono": un enlace, no un tercer boton que compita con los arreglos. */
.aviso-ayuda {
    flex: 0 0 auto;
    border: 0;
    background: none;
    padding: 0;
    font-size: 0.8em;
    color: #5a6878;
    text-decoration: underline;
    cursor: pointer;
}

.aviso-ayuda:hover {
    color: #2c3a48;
}

.aviso-consejo {
    flex: 1 1 100%;
    padding: 10px 12px 2px 28px;
    border-top: 1px dashed rgba(61, 74, 88, 0.2);
    font-size: 0.85em;
    color: #3d4a58;
}

/* `>>>`: el contenido llega por v-html y el scoped no lo alcanza. */
.aviso-consejo >>> ol,
.aviso-consejo >>> ul {
    margin: 4px 0 8px;
    padding-left: 18px;
}

.aviso-consejo >>> li {
    margin-bottom: 3px;
}

.aviso-consejo >>> p {
    font-size: 1em;
    margin: 0 0 8px;
}

.avisos-orden {
    margin: 0 0 2px;
    font-size: 0.82em;
    color: #5a6878;
}

.aviso-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ---- Barra de grupos ---- */
.arb-barra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
    margin-bottom: 16px;
    background: #f7f9fb;
    border: 1px solid #e6e9ef;
    border-radius: 4px;
}

.arb-barra button {
    border: 1px solid #dde2e9;
    background: #fff;
    border-radius: 3px;
    padding: 6px 13px;
    font-size: 0.82em;
    color: #4a5765;
}

.arb-barra button:hover {
    border-color: #009982;
    color: #009982;
}

.arb-barra button[aria-current="true"] {
    background: #009982;
    border-color: #009982;
    color: #fff;
    font-weight: 600;
}

.arb-barra .sep {
    margin-left: auto;
}

/* ---------------------------------------------------------------------------
   Interruptor de lista / columnas

   Dos iconos desnudos, sin caja: es un cambio de vista, no una accion, y con
   borde y relleno pesaba mas que el contenido de la pantalla. Lo unico que
   cambia es el color del icono -gris apagado, turquesa el que esta puesto y al
   pasar por encima-, asi que hay que deshacer el borde, el fondo y el hover que
   heredan de `.arb-barra button`.
   --------------------------------------------------------------------------- */
.disposicion {
    display: inline-flex;
    gap: 2px;
    margin-right: 6px;
}

.arb-barra .disp-btn {
    background: transparent;
    border: 0;
    width: 30px;
    padding: 6px 0;
    text-align: center;
    color: #aab4c0;
}

/* Turquesa aclarado, no el pleno: el hover insinua "puedes poner esta vista", y el
   pleno se reserva para la que YA esta puesta. Si los dos fueran iguales, al pasar
   por encima del apagado pareceria que se ha cambiado de vista.

   La regla del que esta puesto va despues y con la misma especificidad, asi que
   gana: pasar por encima del activo no lo apaga. */
.arb-barra .disp-btn:hover {
    background: transparent;
    border: 0;
    color: #4cb8a7;
}

.arb-barra .disp-btn[aria-pressed="true"] {
    color: #009982;
}

.arb-barra .cnt {
    font-variant-numeric: tabular-nums;
    opacity: 0.75;
}

/* ---- Tabla ---- */
.sector-tabla {
    width: 100%;
    margin-bottom: 0;
    border-collapse: collapse;
}

.sector-tabla thead th {
    background: #2c3e50;
    color: #fff;
    border: 0;
    padding: 11px 18px;
    font-size: 0.76em;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
    text-align: left;
}

.sector-tabla tbody tr {
    border-bottom: 1px solid #eef1f5;
}

.sector-tabla tbody tr:last-child {
    border-bottom: 0;
}

.sector-tabla tbody td {
    padding: 12px 18px;
    border: 0;
    vertical-align: middle;
}

.sector-tabla tbody tr:nth-child(even) td {
    background: #fcfdfe;
}

.sector-tabla tbody tr:hover td {
    background: rgba(0, 153, 130, 0.08);
}

.sector-tabla th.num,
.sector-tabla td.num {
    text-align: right;
    white-space: nowrap;
}

.sector-tabla td.num {
    font-variant-numeric: tabular-nums;
    color: #3d4a58;
}

.sector-tabla th.acc,
.sector-tabla td.acc {
    text-align: center;
    white-space: nowrap;
    width: 92px;
}

.cat-nombre {
    font-weight: 600;
}

/* El estado va debajo del nombre y no en una columna propia: es una frase, no un
   dato, y en columna obligaria a recortarla. */
.cat-estado {
    display: block;
    font-size: 0.8em;
    margin-top: 2px;
}

.cat-estado.ok { color: #98a2ad; }
.cat-estado.warn { color: #96690f; }
.cat-estado.mal { color: #a13a2f; font-weight: 600; }

tr.sin-cat td {
    background: #f7f9fb !important;
}

tr.sin-cat .cat-nombre {
    color: #98a2ad;
    font-style: italic;
    font-weight: 400;
}

.edit-fila td {
    background: rgba(214, 158, 46, 0.09) !important;
}

.edit-linea {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.edit-linea .form-control {
    flex: 1 1 240px;
    width: auto;
}

.edit-nota {
    margin: 8px 0 0;
    font-size: 0.82em;
    color: #7b8794;
}

/* ---- Botones de accion de la fila ---- */
.arb-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 0 2px;
    border: 1px solid transparent;
    border-radius: 3px;
    background: transparent;
    font-size: 0.86em;
    line-height: 1;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
        transform 0.15s ease, box-shadow 0.15s ease;
}

.arb-btn:hover:not(:disabled) {
    transform: translateY(-1px);
}

.arb-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

/* El lapiz en ambar: modifica. Mismo criterio que en la ficha de producto. */
.arb-btn-editar {
    background: rgba(214, 158, 46, 0.12);
    border-color: rgba(214, 158, 46, 0.25);
    color: #96690f;
}

.arb-btn-editar:hover:not(:disabled) {
    background: #d69e2e;
    border-color: #d69e2e;
    color: #fff;
    box-shadow: 0 2px 6px rgba(214, 158, 46, 0.35);
}

.arb-btn-borrar {
    background: rgba(161, 58, 47, 0.1);
    border-color: rgba(161, 58, 47, 0.22);
    color: #a13a2f;
}

.arb-btn-borrar:hover:not(:disabled) {
    background: #a13a2f;
    border-color: #a13a2f;
    color: #fff;
    box-shadow: 0 2px 6px rgba(161, 58, 47, 0.3);
}

.arb-btn-ver {
    background: rgba(0, 153, 130, 0.1);
    border-color: rgba(0, 153, 130, 0.2);
    color: #00745f;
}

.arb-btn-ver:hover:not(:disabled) {
    background: #009982;
    border-color: #009982;
    color: #fff;
    box-shadow: 0 2px 6px rgba(0, 153, 130, 0.3);
}

/* ---- Botones ---- */
.btn-verde {
    background: #009982;
    border: 1px solid #009982;
    color: #fff;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
    font-weight: 600;
}

.btn-verde:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.btn-claro {
    background: #fff;
    border: 1px solid #dde2e9;
    color: #4a5765;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
}

.btn-claro:hover:not(:disabled) {
    border-color: #009982;
    color: #009982;
}

.btn-claro:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.vacio {
    padding: 22px 18px;
    text-align: center;
    color: #98a2ad;
    font-size: 0.9em;
    margin: 0;
}

.pie {
    display: flex;
    justify-content: center;
}

.foot {
    padding-top: 14px;
    color: #98a2ad;
    font-size: 0.84em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/CategoriasGenerales/CategoriasNegocio.vue